import PropTypes from "prop-types";

import Presenter from "utils/PropTypesPresenter";
import TemplateGroupPresenter from "presenters/TemplateGroupPresenter";

export default new Presenter(
  {
    id: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
    ghostThumbnail: PropTypes.string,
  },

  {
    thumb(tg) {
      return this.ghostThumbnail(tg);
    },

    castNumOptions(tg) {
      return TemplateGroupPresenter.castNumOptions(tg);
    },

    castsCount(tg) {
      const { castNumOptions } = tg;
      return castNumOptions[0];
    },

    allCardsCount(items) {
      return items && items.length;
    },
  },
);
